import { Container } from './styles';
import { motion } from 'framer-motion';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { CustomTimeLineDot, Heading, ImageContainer, CustomTimelineConnector, ContentWrapperLeft, ContentWrapperRight, StyledParagraph } from './styles';
import { TimelineContent, TimelineItem, TimelineOppositeContent } from '@mui/lab';

interface CustomTimelineItemComponentProps {
    imagePath: string;
    heading: string;
    paragraph: string;
    paragraphAnimation: any;
    imageAnimation: any;
    contentLeft: boolean;
}

const CustomTimelineElement = ({ imagePath, heading, paragraph, paragraphAnimation, imageAnimation, contentLeft }: CustomTimelineItemComponentProps) => {
    return (
        contentLeft ? (
            <Container>
                <TimelineItem>
                    <TimelineOppositeContent>
                        <ContentWrapperLeft>
                            <motion.div {...imageAnimation}>
                                <ImageContainer>
                                    <img src={imagePath} alt="history" />
                                </ImageContainer>
                            </motion.div>
                        </ContentWrapperLeft>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <CustomTimeLineDot />
                        <CustomTimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                        <ContentWrapperRight>
                            <motion.div {...paragraphAnimation}>
                                <Heading lang='de'>{heading}</Heading>
                                <StyledParagraph>
                                    {paragraph}
                                </StyledParagraph>
                            </motion.div>
                        </ContentWrapperRight>
                    </TimelineContent>

                </TimelineItem>
            </Container>
        ) : (
            <Container>
                <TimelineItem>
                    <TimelineContent>
                        <ContentWrapperLeft>
                            <motion.div {...paragraphAnimation}>
                                <Heading>{heading}</Heading>
                                <StyledParagraph>
                                    {paragraph}
                                </StyledParagraph>
                            </motion.div>
                        </ContentWrapperLeft>
                    </TimelineContent>
                    <TimelineSeparator>
                        <CustomTimeLineDot />
                        <CustomTimelineConnector />
                    </TimelineSeparator>
                    <TimelineOppositeContent>
                        <ContentWrapperRight>
                            <motion.div {...imageAnimation}>
                                <ImageContainer>
                                    <img src={imagePath} alt="history" />
                                </ImageContainer>
                            </motion.div>
                        </ContentWrapperRight>
                    </TimelineOppositeContent>
                </TimelineItem>
            </Container>
        ))
}

export default CustomTimelineElement;
